import styled from 'styled-components';
import { theme } from 'styled-tools';

import { minWidth } from '@calm-web/design-system';

// Fixed brand colors: the api response carries copy/links/dates, not presentation —
// every past banner instance used this same navy-on-white treatment.
export const StyledBanner = styled.a`
	background-color: #1c2056;
	color: #fff;
	display: flex;
	/* Horizontal padding keeps long api-supplied copy clear of the fixed close control
	   that sits over the banner's right edge. */
	padding: 8px 48px;
	justify-content: center;
	align-items: center;
	cursor: pointer;
	position: fixed;
	left: 0;
	right: 0;
	top: 0;
	z-index: 1000;
	height: ${theme('app.mobileBannerHeight')};
	text-align: center;

	${minWidth('tablet')} {
		height: ${theme('app.bannerHeight')};
	}
`;

export const BannerMessaging = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
`;

export const BannerTitleGroup = styled.div`
	display: flex;
	flex-direction: column;
`;

export const BannerSubtitle = styled.span`
	font-size: 12px;
`;

export const BannerArrow = styled.span`
	margin-left: 8px;
	display: flex;
	align-items: center;
`;

// Positioned on top of StyledBanner (a sibling, not a child of its anchor) at the same
// fixed placement the banner itself uses, so a click on the close button never bubbles
// into the anchor's own click handler.
export const CloseWrapper = styled.div`
	display: flex;
	align-items: center;
	position: fixed;
	right: 8px;
	top: 0;
	z-index: 1001;
	height: ${theme('app.mobileBannerHeight')};
	padding: 0;

	${minWidth('tablet')} {
		height: ${theme('app.bannerHeight')};
	}
`;

export const CTAText = styled.span`
	display: none;

	${minWidth('mobileLarge')} {
		display: block;
	}
`;
